import {
  GET_WORKSTATION_POSITIONS_STATUS,
  GET_WORKSTATION_POSITIONS_STATUS_SUCCESS,
  GET_WORKSTATION_POSITIONS_STATUS_ERROR,
} from './actionTypes';

const initialState = {
  errorGetWorkstationPositionsStatus: '',
  loadingGetWorkstationPositionsStatus: false,
  positions: null,
};

const getWorkstationPositionsStatus = (state = initialState, action) => {
  switch (action.type) {
    case GET_WORKSTATION_POSITIONS_STATUS:
      state = { ...state, loadingGetWorkstationPositionsStatus: true };
      break;
    case GET_WORKSTATION_POSITIONS_STATUS_SUCCESS:
      state = { ...state, loadingGetWorkstationPositionsStatus: false, positions: action.payload.positions };
      break;
    case GET_WORKSTATION_POSITIONS_STATUS_ERROR:
      state = {
        ...state,
        errorGetWorkstationPositionsStatus: action.payload,
        loadingGetWorkstationPositionsStatus: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getWorkstationPositionsStatus;
